import { render, staticRenderFns } from "./SlackNotificationsConfigForm.vue?vue&type=template&id=5ee632e3&scoped=true"
import script from "./SlackNotificationsConfigForm.vue?vue&type=script&lang=js"
export * from "./SlackNotificationsConfigForm.vue?vue&type=script&lang=js"
import style0 from "./SlackNotificationsConfigForm.vue?vue&type=style&index=0&id=5ee632e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee632e3",
  null
  
)

export default component.exports